import { parse as engineParse, type ExprNode } from '@learnforge/demo-math/expr';

export class ParseError extends Error {
  constructor(
    message: string,
    public readonly position?: number,
  ) {
    super(message);
    this.name = 'ParseError';
  }
}

export interface ParsedExpression {
  node: ExprNode;
  variables: string[];
  source: string;
}

export function parse(src: string): ParsedExpression {
  let result: { node: ExprNode; variables: string[]; source: string };
  try {
    result = engineParse(src);
  } catch (e) {
    throw new ParseError((e as Error).message);
  }
  for (const v of result.variables) {
    if (v !== 'x') {
      throw new ParseError(`Unknown variable "${v}". Only "x" is allowed.`);
    }
  }
  return { node: result.node, variables: result.variables, source: src };
}
